import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation, NavLink } from 'react-router-dom';
import classnames from 'classnames';

const NavigationGroup = ({ group, isCategory }) => {
  const history = useHistory();
  const location = useLocation();
  const currentPath = location.pathname;
  const isSelected = currentPath.includes(group.link) && group.selectable;
  
  const isStreamGuide = group.name === 'Canlı Yayin Rehberi' || group.name === 'Canlı Yayın Rehberi';
  const isStreamGuideActive = isStreamGuide && currentPath.includes('/lig-merkezi/canli-yayin-rehberi');
  const isActive = isSelected || isStreamGuideActive;

  const groupClass = classnames({
    group__title: !isCategory,
    group__category: isCategory,
    group__title_selected: isActive,
    'navigation-header': group.isHeader
  });

  const handleCategoryClick = useCallback(e => {
    e.preventDefault();
    
    if (isStreamGuide || group.selectable) {
      const search = location?.search || '';
      history.push(`${ group.link }${ search }`);
    }
  }, [group.link, group.selectable, history, isStreamGuide, location]);

  return (
    <NavLink
      to={ group.link }
      title={ group.name }
      className={ groupClass }
      onClick={ handleCategoryClick }
      style={ {
        fontWeight: isActive ? '700' : '500',
        cursor: (isStreamGuide || group.selectable) ? 'pointer' : 'default'
      } }
    >
      { group.name }
      { group.tag && <span className="group__tag">{ group.tag }</span> }
    </NavLink>
  );
};

NavigationGroup.propTypes = {
  group: PropTypes.shape({
    name: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    selectable: PropTypes.bool,
    tag: PropTypes.string,
    color: PropTypes.string,
    icon: PropTypes.string,
    isHeader: PropTypes.bool
  }).isRequired,
  isCategory: PropTypes.bool
};

NavigationGroup.defaultProps = {
  isCategory: false
};

export default React.memo(NavigationGroup);
